module.exports = __webpack_public_path__ + "static/21-09ef7eaa988e9837b348ffd220a4794b.jpg";